// Single source of truth for the storefront header promo defaults.
//
// The header sub-bar shows a free-shipping promo: a monthly-rotating emoji, an
// HTML message, and a link to /discounts?<query>. An admin can override these
// for a campaign (see the "header promo" Setting + HeaderPromo::active()); when
// no custom promo is active the header falls back to the constants below.
//
// Consumed by the storefront layout (live header) and the admin Header Promo
// card (the 12-month reference table).

// Default emoji per calendar month (index 0 = January). The header shows
// HEADER_EMOJI_BY_MONTH[new Date().getMonth()] when no custom promo is active.
export const HEADER_EMOJI_BY_MONTH = ["☃️", "💕", "☘️", "☔️", "🌸", "☀️", "🇺🇸", "🏖️", "📚", "🍁", "🦃", "🎁"];

// Human labels aligned with HEADER_EMOJI_BY_MONTH for the admin reference table.
export const MONTH_LABELS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

// Evergreen default link query + message (inner HTML of the <strong>). The
// message references the same code the query points at; keep them in sync.
export const DEFAULT_PROMO_QUERY = "discount=FREE99";
export const DEFAULT_PROMO_MESSAGE = 'Spend $99, get free shipping! Use code <span class="code">FREE99</span> at checkout.';

// The default emoji for a given month, honoring an optional admin override
// array (blank/missing entries fall back to the built-in default).
export function emojiForMonth(month, overrides) {
  return (overrides && overrides[month]) || HEADER_EMOJI_BY_MONTH[month];
}
